// React
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'
import uiConnect from 'shared/redux/interface'
import { compose } from 'redux'

// Libraries

// Components
import ProductButton from 'store/modules/product/components/ProductButton'
import ProductImage from 'store/modules/product/components/ProductImage'

// Shared
import { triggerUserFrameworkViewProductEvent } from 'shared/utils/userFrameworkEvents'
import productSelectors from 'store/v2/redux/selectors/product'
import BundleActions from 'store/v2/redux/actions/bundle'
import ProductGroupActions from 'store/v2/redux/actions/product_group'

class ProductDetail extends Component {
  static displayName = 'ProductDetail'

  static propTypes = {
    onChangeProductId: PropTypes.func,
    item: PropTypes.object,
    product: PropTypes.object,
    bundleItems: PropTypes.any,
    selectedProductId: PropTypes.string,
    ui: PropTypes.object,
    cart: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      triggeredTracking: false,
      hovered: false,
      loading: false
    }
  }

  componentDidUpdate = (prevProps) => {
    const { product, bundleItems } = this.props

    // On mount window.Booqable.data is not set yet. By keeping track of whether this is triggered,
    // we can use the data in reporting events. In this event we also include Bundle data.
    if (product && !this.state.triggeredTracking) {
      const isBundle = product.type === 'Bundle'

      if (isBundle && !bundleItems) return

      this.setState({ triggeredTracking: true })

      triggerUserFrameworkViewProductEvent(product, isBundle && bundleItems)
    }

    if (this.props.ui?.selectedProductId && this.props.ui?.selectedProductId !== prevProps.ui?.selectedProductId) {
      triggerUserFrameworkViewProductEvent(product)
    }
  }

  componentDidMount = () => {
    const { product, item } = this.props
    const productDataFresh =
      product?.price_each_in_cents === item?.price_each_in_cents &&
      product?.charge_label === item?.charge_label &&
      product?.available_quantity === item?.available_quantity

    if (productDataFresh || window.bqFetchingDetailProducts) return

    this.fetchData()
  }

  fetchData = () => {
    const { item, cart } = this.props

    this.setState({ loading: true })

    const callback = () => this.setState({ loading: false })

    if (item.type === 'ProductGroup') {
      return ProductGroupActions.fetchAll({
        ids: [item.id],
        cart_id: cart && cart.id,
        include: 'photos,products',
        apiVersion: 3
      }).then(callback)
    } else if (item.type === 'Bundle') {
      return BundleActions.fetchAll({
        ids: [item.id],
        cart_id: cart && cart.id,
        include: [
          'photos', 'bundle_items', 'bundle_items.product', 'bundle_items.product.photo',
          'bundle_items.product_group', 'bundle_items.product_group.products',
          'bundle_items.product_group.photo', 'bundle_items.product_group.products',
          'bundle_items.product_group.products.photo'
        ].join(','),
        apiVersion: 3
      }).then(callback)
    }
  }

  render = () => {
    const { item } = this.props
    const { loading } = this.state

    return (
      <div className="booqable-product-detail-wrapper" data-tid="Product detail">
        <ProductImage alt={this.props.product?.name} ownerId={item.id} itemTitle={item.name || null} photoId={this.props.product && this.props.product.photo_id} />
        <div className="bq-content">
          <h3 className="bq-product-name">
            {item && item.name}
          </h3>
          {item &&
            (
              <ProductButton
                uiKey={item.id}
                item={item}
                onChangeProductId={this.props.onChangeProductId}
                loading={loading}
              />
            )}
          {item && item.description &&
            <div className="bq-product-description rx-reset rx-content" dangerouslySetInnerHTML={{ __html: item.description }} />}
        </div>
      </div>
    )
  }
}

const uiToProps = {
  state: {
    selectedProductId: null
  }
}

const mapStateToProps = (state, props) => {
  const item = props.item || state.orm.items.getById(props.itemId)
  const selectedProduct = productSelectors.selectedForProductGroup(
    state.orm.products.sort('sorting_weight'),
    props.ui != null ? props.ui.selectedProductId : undefined,
    item.id
  )
  const bundle = item.type === 'Bundle' && state.orm.bundles.getById(item.id)
  const bundleItems = bundle && state.orm.bundle_items.getById(bundle.bundle_items)

  return {
    item,
    translations: state.client.get('translations').toJS(),
    product: selectedProduct,
    cart: state.orm.carts.getById(state.client.cartId),
    bundle,
    bundleItems
  }
}

const mapDispatchToProp = (_, props) => {
  return {
    onChangeProductId (id) {
      return props.updateUI({ selectedProductId: id })
    }
  }
}

export default compose(
  uiConnect('ProductDetail', uiToProps),
  reduxConnect(mapStateToProps, mapDispatchToProp)
)(ProductDetail)
